export class ClassificationExpectation {
    id: number;
    handicap: number;
    positionOne: boolean;
    horse: boolean;

    split: number;
    catch: number;
    rawActualTime: number;
    error: number;

    constructor(positionOne: boolean, horse: boolean) {
        this.positionOne = positionOne;
        this.horse = horse;
    }
}


// WEBPACK FOOTER //
// ./src/model/classification-expectation.ts